/* edit.icon.svg.js */

module.exports = {
    icon: `    
            <svg viewBox="0 0 16 16" preserveAspectRatio="none">
                <path class="foreground-gl" d="M0.8,0h9.6c0.2,0,0.4-0.1,0.6,0c0.5,0.3,0.6,0.9,0.2,1.3l-0.5,0.5c-0.2,0.2-0.6,0-0.6-0.3v0C10,1.5,9.9,1,9.8,1
                    H1.3C1.2,1,1,1.5,1,1.6V14c0,0.1,0.2,0,0.3,0h8.5c0.1,0,0.2,0.1,0.2,0v-2.6c0-0.1,0-0.2,0.1-0.3l1.1-0.9c0.2-0.2,0.8-0.1,0.8,0.3
                    v4.1c0,0.7-0.9,1.4-1.6,1.4c-4.5,0-5.1,0-9.6,0C0.1,16,0,15.3,0,14.6V1C0,0.3,0.1,0,0.8,0L0.8,0z M12.8,1.6c-0.1,0.1-0.1,0.2,0,0.3
                    l2.3,2.3c0.1,0.1,0.2,0.1,0.3,0l0.3-0.3c0.4-0.4,0.4-1,0-1.4l-1.2-1.2c-0.4-0.4-1-0.4-1.4,0L12.8,1.6z M12.3,2.4
                    c-0.1-0.1-0.2-0.1-0.3,0l-0.3,0.3l0,0L6.4,7.9c0,0,0,0.1-0.1,0.1l-0.4,2.8c0,0.1,0.1,0.2,0.2,0.2l2.8-0.4c0,0,0.1,0,0.1-0.1l5.2-5.2
                    l0,0L14.6,5c0.1-0.1,0.1-0.2,0-0.3L12.3,2.4z M13.6,5L9.2,9.4l0-0.3c0-0.1,0-0.1-0.1-0.2L8.9,8.9C8.8,8.8,8.8,8.7,8.9,8.6l4.2-4.2
                    c0.1-0.1,0.2-0.1,0.3,0l0.3,0.3C13.7,4.8,13.7,4.9,13.6,5z M7.1,8.2l0.5,0.1c0.1,0,0.1,0.1,0.2,0.1l0.2,0.5C7.9,9,8,9,8,9l0.6,0.3
                    c0.1,0,0.1,0.1,0.1,0.2l0,0.4L8.7,10l-1.1,0.2c-0.1,0-0.1,0-0.2-0.1L6.9,9.6c0,0-0.1-0.1-0.1-0.2L7.1,8.2L7.1,8.2z M7.8,7.6L12,3.4
                    c0.1-0.1,0.2-0.1,0.3,0l0.3,0.3c0.1,0.1,0.1,0.2,0,0.3L8.4,8.1C8.3,8.2,8.1,8.1,8.1,8l0,0C8,8,8,8,7.9,8h0C7.8,8,7.7,7.7,7.8,7.6z"
                    />
            </svg>
         `
};
